<template>
  <el-select   filterable v-model="useModel" :clearable="true" placeholder="Select" :disabled="disabled" >
    <el-option v-for="approval in options" :value="approval.id" :label="approval.label" :key="approval.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    inputModel: {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      options: [{
        id: 0,
        label: 'Yes'
      }, {
        id: 1,
        label: 'No'
      }, {
        id: 2,
        label: 'Ignore'
      }]
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
